import { useMemo, useState } from 'react';
import { Option, OptionKey } from '@common-fe/common-fe';

import { SubstantiationRatePayload } from '../../NewStatistics.types';
import { SubstantiationRateRange } from '../SubstantiationRateStatistic.types';

export const SUBSTANTIATION_RATE_OPTIONS: Option[] = [
  {
    key: SubstantiationRateRange.YTD,
    value: 'YTD',
  },
  {
    key: SubstantiationRateRange.NinetyDays,
    value: '90D',
  },
  {
    key: SubstantiationRateRange.ThirtyDays,
    value: '30D',
  },
];

interface UseSubstantiationRateLogicParams {
  data: SubstantiationRatePayload | null;
}

/**
 * Owns the selected range and resolves the matching percentage.
 * Receives data as a parameter, so no query hooks are used here.
 */
export const useSubstantiationRateLogic = ({ data }: UseSubstantiationRateLogicParams) => {
  const [currentRange, setCurrentRange] = useState<OptionKey>(SubstantiationRateRange.YTD);

  const percents = useMemo(() => {
    if (!data) {
      return null;
    }
    if (currentRange === SubstantiationRateRange.NinetyDays) {
      return data.ninetyDays;
    }
    if (currentRange === SubstantiationRateRange.ThirtyDays) {
      return data.thirtyDays;
    }
    return data.ytd;
  }, [currentRange, data]);

  return {
    options: SUBSTANTIATION_RATE_OPTIONS,
    currentRange,
    setCurrentRange,
    percents,
  };
};

export default useSubstantiationRateLogic;
